import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "starsFilled"
const StarsFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M10.14 18.382C10.36 18.065 10.84 18.065 11.06 18.382L11.103 18.455 11.317 18.884 11.746 19.098C12.159 19.306 12.16 19.897 11.746 20.104L11.316 20.318 11.104 20.747C10.895 21.16 10.305 21.16 10.097 20.747L9.882 20.317 9.455 20.105C9.04 19.897 9.04 19.306 9.455 19.098L9.882 18.883 10.097 18.456zM15.782 11.87C16.17 11.096 17.234 11.047 17.707 11.726L17.793 11.871 18.347 12.977 19.455 13.532C20.282 13.947 20.282 15.129 19.455 15.543L18.347 16.097 17.793 17.205C17.378 18.032 16.197 18.032 15.782 17.205L15.227 16.097 14.121 15.543C13.293 15.128 13.293 13.947 14.12 13.532L15.227 12.977zM7.532 3.62C7.92 2.846 8.984 2.797 9.457 3.476L9.544 3.621 10.848 6.226 13.455 7.532C14.282 7.947 14.282 9.128 13.455 9.543L10.848 10.848 9.543 13.455C9.128 14.282 7.947 14.282 7.532 13.455L6.226 10.848 3.621 9.543C2.793 9.128 2.793 7.947 3.62 7.532L6.226 6.226z" />
        </svg>
      }
    </span>
  )
}
export default StarsFilledIcon
